export default __webpack_public_path__ + "static/media/prize-4-bm.fb9e42e9.webp";